var defaultSort = "color";
var defaultSortMode = "asc";
var defaultShapeFilters = "Oval";
var defaultClarityFilters = "VS1,VS2,VVS1,VVS2";
var defaultColorFilters = "D,E,F,G,H,I";
var defaultPriceMin = 0;
var defaultPriceMax = 9999999;
var defaultCaratMin = "1.0";
var defaultCaratMax = "20.0";
export var defaultOptions = {
  active: true,
  labGrown: true,
  sold: false,
  shape: "Oval",
  pageSize: 15,
  page: 1,
  startingPrice: "0",
  endingPrice: "999999",
  sortBy: "retail_price",
  sort: "asc",
  caratWeightFrom: "1.0",
  caratWeightTo: "20,0",
  color: "D,E,F,G,H",
  clarity: "FL,IF,VVS1,VVS2,VS1,VS2",
};

var defaultOptionsSearch = {
  sku_or_gia: "",
};

export async function searchDiamondsBySku(apiBase, apiEndpoints, shape, sku) {
  const query = Object.keys(defaultOptionsSearch)
    .map((optionKey) => {
      var returnVal = defaultOptionsSearch[optionKey];
      if (optionKey === "sku_or_gia") returnVal = sku;
      return `${optionKey}=${returnVal}`;
    })
    .join("&");

  // console.log("query", query);
  const endpoint = apiEndpoints.search;
  const response = await fetch(`${apiBase}/${endpoint}?${query}`);
  if (response.status !== 200) return { diamonds: [] };
  const data = await response.json();
  return { diamonds: data };
}

export async function fetchDiamonds(
  apiBase,
  apiEndpoints,
  options,
  type = "list"
) {
  const { filters, sortBy, page } = options;

  const query = Object.keys(defaultOptions)
    .map((optionKey) => {
      var returnVal = defaultOptions[optionKey];
      // console.log(optionKey, filters);
      // Filterable
      // if (optionKey === "max_price")
      //   returnVal =
      //     filters
      //       .filter((filterValue) => filterValue.type === "price")
      //       .map((filterValue) => filterValue.queryValue)
      //       .join(",") || defaultPriceFilters;
      if (optionKey === "shape")
        returnVal =
          filters
            .filter((filterValue) => filterValue.type === "shape")
            .map((filterValue) => filterValue.queryValue)
            .join(",") || defaultShapeFilters;
      if (optionKey === "color")
        returnVal =
          filters
            .filter((filterValue) => filterValue.type === "color")
            .map((filterValue) => filterValue.queryValue)
            .join(",") || defaultColorFilters;
      if (optionKey === "clarity")
        returnVal =
          filters
            .filter((filterValue) => filterValue.type === "clarity")
            .map((filterValue) => filterValue.queryValue)
            .join(",") || defaultClarityFilters;
      if (optionKey === "startingPrice") {
        returnVal = defaultPriceMin;
        var filterPriceMin = filters.find(
          (filterValue) => filterValue.type === "retail_price"
        );
        if (filterPriceMin) {
          //var minPrice = parseFloat(filterPriceMin.min).toFixed(2);
          var minPrice = parseInt(filterPriceMin.min);
          returnVal = minPrice;
        }
      }
      if (optionKey === "endingPrice") {
        returnVal = defaultPriceMax;
        var filterPriceMax = filters.find(
          (filterValue) => filterValue.type === "retail_price"
        );
        if (filterPriceMax) {
          //var maxPrice = parseFloat(filterPriceMax.max).toFixed(2);
          var maxPrice = parseInt(filterPriceMax.max);
          returnVal = maxPrice;
        }
      }
      if (optionKey === "caratWeightFrom") {
        returnVal = defaultCaratMin;
        var filterCaratsMin = filters.find(
          (filterValue) => filterValue.type === "carats"
        );
        if (filterCaratsMin) {
          var caratsMin = filterCaratsMin.min;
          returnVal = caratsMin.toFixed(2);
        }
      }
      if (optionKey === "caratWeightTo") {
        returnVal = defaultCaratMax;
        var filterCaratsMax = filters.find(
          (filterValue) => filterValue.type === "carats"
        );
        if (filterCaratsMax) {
          var caratsMax = filterCaratsMax.max;
          returnVal = caratsMax.toFixed(2);
        }
      }
      if (optionKey === "page") returnVal = page;

      // Sort
      if (optionKey === "sortBy")
        returnVal = sortBy && sortBy.type ? sortBy.type : defaultSort;
      if (optionKey === "sort")
        returnVal = sortBy && sortBy.mode ? sortBy.mode : defaultSortMode;

      return `${optionKey}=${returnVal}`;
    })

    .join("&");

  // console.log(page);
  // console.log(query);
  // console.log("page", page);
  const endpoint = apiEndpoints[type];
  const response = await fetch(`${apiBase}/${endpoint}?${query}`);
  // const response = await fetch(`http://localhost:3000/?${query}`);

  const data = await response.json();
  return type === "list" ? { diamonds: data.data, meta: data.pages } : data;
}

export function deleteKey(obj, key) {
  let o = { ...obj };
  delete o[key];
  return o;
}

export function formatCarat(carat) {
  return parseFloat(carat).toFixed(2);
}

export function formatMoney(amount) {
  var currencyFormatter = new Intl.NumberFormat({
    style: "currency",
    currency: "USD",
  });
  return currencyFormatter.format(parseFloat(amount));
}

export function isMobile(opts) {
  const mobileRE =
    /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
  const notMobileRE = /CrOS/;
  const tabletRE = /android|ipad|playbook|silk/i;
  if (!opts) opts = {};
  let ua = opts.ua;
  if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
    ua = ua.headers["user-agent"];
  }
  if (typeof ua !== "string") return false;

  let result =
    (mobileRE.test(ua) && !notMobileRE.test(ua)) ||
    (!!opts.tablet && tabletRE.test(ua));

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf("Macintosh") !== -1 &&
    ua.indexOf("Safari") !== -1
  ) {
    result = true;
  }

  return result;
}

export function getQueryVariable(variable) {
  var query = `${window.location.search.substring(1)}&`;
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  //console.log("Query variable %s not found", variable);
}

export function getQueryObject(search) {
  if (!search || search === "") return;
  var urlParams = new URLSearchParams(window.location.search);
  var entries = urlParams.entries();
  var params = paramsToObject(entries);
  return params;
}
export function createVariantUrl(variantId) {
  var qsObject = getQueryObject(window.location?.search);
  var qsNoVariantObject = deleteKey(qsObject, "variant");
  var qsNoVariantString = Object.keys(qsNoVariantObject)
    .map((i) => `${i}=${qsNoVariantObject[i]}`)
    .join("&");
  var newUrl = `${window.location.protocol}//${window.location.host}${
    window.location.pathname
  }?${variantId ? `variant=${variantId}&` : ""}${qsNoVariantString}`;
  return newUrl;
}

export function paramsToObject(entries) {
  const result = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

/**
 * V360
 * ---------------------------------------------------------------------------------------------
 */

export async function v360LoadSUrl(apiUrl, diamondId, companyId) {
  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      companyID: companyId,
      stoneID: diamondId,
    }),
  });
  const dataSUrl = await response.json();
  return dataSUrl;
}

export function v360GetSubdomain(baseDomain) {
  var matches = baseDomain.match(/(s{1}[0-9]{1,2}\.v360\.in)/i);
  if (!matches || matches.length === 0) return "s1";
  return matches.length && matches.length > 1 ? matches[1] : "s1";
}

export function v360GetDiamondName(urlVideo) {
  var urlParts = urlVideo.split("_");
  var urlFile = urlParts[1];
  return urlFile;
}

export function v360IsVideo(url) {
  return url.indexOf("v360.in") > -1;
}

/**
 * Favorites
 * ---------------------------------------------------------------------------------------------
 */
function getFavoritesFromLocalStorage() {
  var jdDiamondsRef = window.localStorage.getItem("jd_fav");
  if (jdDiamondsRef) {
    return JSON.parse(jdDiamondsRef);
  }
  return [];
}
export function saveFavorite(diamond) {
  if (!diamond || !diamond.id) return;

  var favDiamonds = getFavoritesFromLocalStorage();
  favDiamonds = [...favDiamonds, diamond.id];
  // console.log(favDiamonds, JSON.stringify(diamond));

  window.localStorage.setItem(`jd_${diamond.id}`, JSON.stringify(diamond));
  window.localStorage.setItem("jd_fav", JSON.stringify(favDiamonds));
}
export function removeFavorite(diamond) {
  var favDiamonds = getFavoritesFromLocalStorage();
  favDiamonds = favDiamonds.filter((f) => f !== diamond.id);
  window.localStorage.removeItem(`jd_${diamond.id}`);
  window.localStorage.setItem("jd_fav", JSON.stringify(favDiamonds));
}
export function getFavoriteDiamonds() {
  var favDiamonds = getFavoritesFromLocalStorage();
  var diamonds = [...new Set(favDiamonds)]
    .map((favDiamond) => {
      var itemDiamond = window.localStorage.getItem(`jd_${favDiamond}`);
      if (itemDiamond) {
        return JSON.parse(itemDiamond);
      }
      return null;
    })
    .filter((d) => d);
  return diamonds;
}

export async function checkFavorites(apiUrl) {
  var favDiamonds = getFavoriteDiamonds();
  if (!favDiamonds || favDiamonds.length === 0) return;

  favDiamonds = favDiamonds.map((f) => ({ id: f.id, cert_num: f.cert_num }));
  try {
    var responses = await Promise.all(
      favDiamonds.map((favDiamond) =>
        getShopifyDiamond(apiUrl, favDiamond.cert_num)
      )
    );
    if (responses.length === 0) return;

    // checking the ones that exist
    favDiamonds.forEach((favDiamond) => {
      var diamondExists = responses.find(
        (response) =>
          response &&
          response.handle &&
          response.handle === `diamond-${favDiamond.cert_num}`
      );
      if (!diamondExists) {
        var lsDiamonds = [...new Set(getFavoritesFromLocalStorage())];
        lsDiamonds = lsDiamonds.filter(
          (d) => parseInt(d) !== parseInt(favDiamond.id)
        );
        window.localStorage.setItem("jd_fav", JSON.stringify(lsDiamonds));
        window.localStorage.removeItem(`jd_${favDiamond.id}`);
      }
    });
  } catch (e) {
    console.log(e);
  }
}
/**
 * Save For Later
 * * ---------------------------------------------------------------------------------------------
 */
export function saveForLater(data) {
  // First we store a cookie so it lasts for no more than a day to allow a user
  // to come back to the page without having old data stored
  var sflCookie = readCookie("jd_sfl");
  if (!sflCookie) {
    sflCookie = createCookie("jd_sfl", "saved", 90); // saved for 90 days
  }
  // getSaveForLaterFromLocalStorage(data);
  window.localStorage.setItem("jd_sfl", JSON.stringify(data));
}
export function getSavedForLater() {
  var sflCookie = readCookie("jd_sfl");
  if (sflCookie == "saved") {
    var lsSavedForLater = getSaveForLaterFromLocalStorage();
    return lsSavedForLater;
  }
  return [];
}
function getSaveForLaterFromLocalStorage() {
  var jdSavedForLater = window.localStorage.getItem("jd_sfl");
  if (jdSavedForLater) {
    return JSON.parse(jdSavedForLater);
  }
  return [];
}
export function deleteSavedForLater() {
  eraseCookie("jd_sfl");
}
export function createCookie(name, value, days) {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }

  document.cookie = name + "=" + value + expires + "; path=/";
}
export function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }

  return null;
}
export function eraseCookie(name) {
  createCookie(name, "", -1);
}

/**
 * Pricing
 * * ---------------------------------------------------------------------------------------------
 */
export function getSelectedVariants(selectedOptions, product, mappings) {
  var variantDefiners = ["shape", "metal"];
  var selecteds = {};
  variantDefiners.forEach((definer) => {
    selecteds[definer] = selectedOptions.find(
      (selectedOption) => selectedOption.step.id === definer
    );
  });
  // console.log("selecteds", selecteds);

  var filteredVariants = product.variants.filter((variant) => {
    var selectedsToFilter = Object.keys(selecteds)
      .filter((s) => selecteds[s] !== undefined)
      .map((s) => selecteds[s]);
    // console.log("selectedToFilters", selectedsToFilter);
    return selectedsToFilter.reduce((result, selected) => {
      // console.log(result, selected.step.id, selected.choice.id);
      return (
        result &&
        variant[mappings.product.options[selected.step.id]] ===
          mappings.product[selected.step.id][selected.choice.id]
      );
    }, true);
  });

  return filteredVariants;
}
export function getBaseVariantPrice(selectedOptions, product, mappings) {
  var filteredVariants = getSelectedVariants(
    selectedOptions,
    product,
    mappings
  );

  return filteredVariants
    .map((variant) => variant.price)
    .sort((a, b) => (a.price > b.price ? -1 : 1))[0];
}

/**
 * Availability
 * ----------------------------------------------------------------------------------------------------
 */
// @TODO: check inventory
export function getAvailableVariants(product, mappings) {
  var definers = ["shape", "metal"];
  var availability = definers.map((definer, index) => {
    var variantDefiners = [...definers].splice(0, index + 1);
    var available = [
      ...new Set(
        product.variants
          .filter((variant) => variant.available) // removes variants with no stock or not available
          .map((variant) => {
            return variantDefiners
              .map((variantDefiner) => {
                var optionId = mappings.product.options[variantDefiner];
                var optionValue = variant[optionId];
                return Object.keys(mappings.product[variantDefiner]).find(
                  (key) => mappings.product[variantDefiner][key] === optionValue
                );
              })
              .join(":");
          })
      ),
    ];
    // console.log(definer, available);
    return {
      stepId: definer,
      available,
    };
  });

  return availability;
}

export async function getShopifyDiamond(apiUrl, diamondCertNum) {
  const formData = new FormData();
  formData.append("cert_num", diamondCertNum);
  var response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(formData).toString(),
  });
  var data = await response.json();
  return data;
}

export async function getAvailable3dModels(
  baseJsonUrl,
  baseModel,
  availableVariants,
  mappings,
  metafieldAvailability
) {
  var shapeAvailability = availableVariants.find((av) => av.stepId === "shape");
  var allAvailableShapes = shapeAvailability.available.map((av) => ({
    id: av,
    name: mappings.product.shape[av],
    name3d: mappings.viewer3d.shape[av],
  }));
  // console.log(allAvailableShapes, baseJsonUrl, baseModel);
  return allAvailableShapes.map((av) => ({
    id: av.id,
    name: av.name,
    available: metafieldAvailability.find((mfAv) => mfAv === av.name3d)
      ? true
      : false,
    url: `${baseJsonUrl}/${baseModel}-${baseModel}-2.00.json`,
  }));
}

export async function checkAvailable3dModels(
  baseJsonUrl,
  baseModel,
  availableVariants,
  mappings
) {
  var shapeAvailability = availableVariants.find((av) => av.stepId === "shape");
  // console.log(shapeAvailability);
  var allAvailableShapes = shapeAvailability.available.map((av) => ({
    id: av,
    name: mappings.product.shape[av],
    name3d: mappings.viewer3d.shape[av],
  }));
  var jsonFiles = allAvailableShapes.map((av) => ({
    id: av.id,
    name: av.name,
    url: `${baseJsonUrl}/${baseModel}-${av.name3d}-2.00.json`,
  }));

  try {
    var responses = await Promise.all(
      jsonFiles.map((jsonFile) => fetch(jsonFile.url))
    );
    if (responses.length === 0);
    var availableModels = responses.map((response) => ({
      ...jsonFiles.find((jf) => jf.url === response.url),
      available: response.status === 200,
    }));
    return availableModels;
  } catch (e) {
    console.log(e);
  }
  return [];
}

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
  str = str.toLowerCase(); // convert string to lowercase
  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
  return str;
}
